export const setEmpresa = (empresa) => ({
    type: 'SET_EMPRESA',
    payload: empresa,
});
